<template>
    <div class="container equity-container">
         <div class="equity-main">
             <template v-if="equity=='bjx'">
                 <bjx></bjx>
             </template>
             <template v-else-if="equity=='tjx'">
                 <tjx></tjx>
             </template>
         </div>
    </div>
</template>

<script>
    import bjx from './bjx/index';
    import tjx from './tjx/index';
    export default {
        data(){
            return {equity:'',id:''}
        },
        components:{
            bjx,
            tjx
        },
        mounted(){
            this.equity=this.$route.params.equity;
            this.id=this.$route.params.id;
            $(window).scrollTop(0);
        }
    }
</script>

<style lang="scss" scoped>

</style>